module.exports = __webpack_public_path__ + "img/hiper.dacc708.svg";